import type { MyvLocale } from "@/locales/fr/myv";

import { EMyVModeType } from "@/types/backoffice/dto/myv/myv-mode-type-dto.ts";
import { EMyVPRogrammingType } from "@/types/backoffice/dto/myv/myv-programming-type-dto.ts";
import { EMyVPlanningMode } from "@/types/backoffice/dto/myv/planning-mode-dto";

const myvLocale: MyvLocale = {
  myv: {
    programming: {
      type: {
        [EMyVPRogrammingType.DEFAULT]: "Default",
        [EMyVPRogrammingType.USER]: "User",
        [EMyVPRogrammingType.QUICK]: "Quick",
        [EMyVPRogrammingType.MANUAL]: "Manual",
        [EMyVPRogrammingType.UNKNOWN]: "Unknown",
        [EMyVPRogrammingType.ERROR]: "Error",
      },
      mode: {
        [EMyVModeType.NORMAL]: "Normal",
        [EMyVModeType.CONFORT]: "Comfort",
        [EMyVModeType.CONFORTMINUS1]: "Comfort -1",
        [EMyVModeType.CONFORTMINUS2]: "Comfort -2",
        [EMyVModeType.ECO]: "Eco",
        [EMyVModeType.ECOV]: "Eco V",
        [EMyVModeType.HORS_GEL]: "No Frost",
        [EMyVModeType.TEMPERATURE]: "Temperature",
        [EMyVModeType.ARRET]: "Stop",
        [EMyVModeType.UNKNOWN]: "Unknown",
        [EMyVModeType.ERROR]: "Error",
      },
      planningMode: {
        [EMyVPlanningMode.NORMAL]: "Normal",
        [EMyVPlanningMode.ECO]: "Eco",
        [EMyVPlanningMode.TEMPERATURE]: "Temperature",
        [EMyVPlanningMode.COMFORT_ON]: "Comfort",
        [EMyVPlanningMode.COMFORT_1]: "Comfort",
        [EMyVPlanningMode.COMFORT_2]: "Comfort",
        [EMyVPlanningMode.NO_FROST]: "No Frost",
        [EMyVPlanningMode.STOP]: "Stop",
        [EMyVPlanningMode.ECO_V]: "Eco V",
        [EMyVPlanningMode.UNKNOWN]: "Unknown",
      },
    },
  },
};

export default myvLocale;
